/** Shopify CDN: Minification failed

Line 8:0 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 8:49 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 8:60 Transforming const to the configured target environment ("es5") is not supported yet

**/
class FacetRemove extends HTMLElement{constructor(){super();const e=this.querySelector("a");e.addEventListener("click",(t=>{t.preventDefault();(this.closest("collection-filters-form")||document.querySelector("collection-filters-form")).renderPage(new URL(e.href).searchParams.toString())}))}}customElements.define("facet-remove",FacetRemove);